export default __webpack_public_path__ + "static/media/donate-title-img.2148af5b.png";